var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWolframalpha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.125 126.587L252.005 87.9406L205.725 73.554L204.838 23.6207L157.018 41.1073L127.965 1.33398L98.9112 39.414L49.3912 23.6207L50.5846 72.4206L2.53122 88.214L31.2979 126.587L1.33789 165.134L50.5846 180.747V227.301L98.9112 213.754L128.305 254.667L157.018 213.467L204.838 227.301V180.467L254.671 165.134L224.125 126.587Z",
    fill: "#FD745C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8233 111.954L78.25 59.5469L128.297 78.1735V126.594L80.8233 111.954Z",
    fill: "#FF4527"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.012 165.135V213.468L204.832 227.301V180.468L157.012 165.135Z",
    fill: "#EC2101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.305 207.834L98.9121 165.14L128.305 126.594L157.019 165.14L128.305 207.834Z",
    fill: "#FF9281"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9121 39.414L127.965 1.33398L157.019 41.1073L128.305 78.1673L98.9121 39.414Z",
    fill: "#FF9281"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.375 111.953L205.722 73.5527L252.002 87.9394L224.122 126.586L176.375 111.953Z",
    fill: "#FF8B79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.301 126.586L176.374 111.953L209.281 151.906L157.014 165.133L128.301 126.586Z",
    fill: "#FD684D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8254 111.952L50.5787 72.4189L2.52539 88.2123L31.2921 126.586L80.8254 111.952Z",
    fill: "#FF3413"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.301 78.1658L177.661 58.8791L204.834 23.6191L157.014 41.1058L128.301 78.1658Z",
    fill: "#EF5240"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128.301 126.585V78.1654L177.661 58.8721L176.374 111.945L128.301 126.585Z",
    fill: "#E63320"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9009 165.135V213.755L50.5742 227.301V180.748L98.9009 165.135Z",
    fill: "#D21C22"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2979 126.586L80.8312 111.953L46.4979 149.406L1.33789 165.133L31.2979 126.586Z",
    fill: "#EC2101"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8267 111.952L50.5801 72.4191L49.3867 23.6191L78.2534 59.5391L80.8267 111.952Z",
    fill: "#DC1D23"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9121 165.135V213.755L128.305 254.668V207.835L98.9121 165.135Z",
    fill: "#B4151B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.012 165.133L209.272 151.906L254.665 165.133L204.832 180.466L157.012 165.133Z",
    fill: "#C90901"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.375 111.952L205.722 73.5525L204.835 23.6191L177.662 58.8791L176.375 111.952Z",
    fill: "#FD694F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2534 59.5391L128.3 78.1658L98.9067 39.4125L49.3867 23.6191L78.2534 59.5391Z",
    fill: "#FD694F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.014 165.135V213.468L128.301 254.668V207.835L157.014 165.135Z",
    fill: "#D21C22"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M176.375 111.953L209.275 151.906L254.668 165.133L224.122 126.586L176.375 111.953Z",
    fill: "#FF482C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5846 180.746L98.9112 165.133L46.4979 149.406L1.33789 165.133L50.5846 180.746Z",
    fill: "#B6171E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.3 126.586L98.9067 165.133L46.5 149.406L80.8333 111.953L128.3 126.586Z",
    fill: "#FD745C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWolframalpha);
export default __webpack_public_path__ + "static/media/wolframalpha.24726d346e149b8f5b90b249efe71b15.svg";
export { ForwardRef as ReactComponent };